import { ObjectsView } from "@organisms"

import { CLIENTS_ROUTES } from "@routes/clients"

export const ClientObjectsViewTabs = () => (
    <ObjectsView.Tabs>
        <ObjectsView.Tab
            id="all_active"
            phase="active"
            title="All Active"
            isDefaultActiveTabForPhase={true}
            endpointKwargs={[
                ["ordering", "name"],
                ["is_active", "true"],
            ]}
            listEndpoint={CLIENTS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={CLIENTS_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="all_inactive"
            phase="inactive"
            title="All Inactive"
            isDefaultActiveTabForPhase={true}
            endpointKwargs={[
                ["ordering", "name"],
                ["is_active", "false"],
            ]}
            listEndpoint={CLIENTS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={CLIENTS_ROUTES.COUNT}
        />
    </ObjectsView.Tabs>
)
